import axios from "axios";
import { waitForFirebaseUser } from "./firebaseAuthHelper";

const API_BASE = "https://modularobjects.com/mailserver/api/interior";

async function authConfig() {
  const user = await waitForFirebaseUser();
  const token = await user.getIdToken();

  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
}

const interiorEditorApi = {
  async listProjects() {
    const config = await authConfig();
    const { data } = await axios.get(`${API_BASE}/projects`, config);
    return data;
  },

  async getProject(id) {
    const config = await authConfig();
    const { data } = await axios.get(`${API_BASE}/projects/${id}`, config);
    return data;
  },

  async createProject(payload) {
    const config = await authConfig();
    const { data } = await axios.post(`${API_BASE}/projects`, payload, config);
    return data;
  },

  async saveProject(id, payload) {
    const config = await authConfig();
    const { data } = await axios.put(`${API_BASE}/projects/${id}`, payload, config);
    return data;
  },

  async deleteProject(id) {
    const config = await authConfig();
    const { data } = await axios.delete(`${API_BASE}/projects/${id}`, config);
    return data;
  },
};

export default interiorEditorApi;